let subscribers = {};

const PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  optionValueSelectionChange: 'option-value-selection-change',
};
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

// AURALA: expose Dawn-style pubsub globals for other theme scripts
window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || PUB_SUB_EVENTS;
window.subscribe = window.subscribe || subscribe;
window.publish = window.publish || publish;